import {
  initialState,
  Actions,
  State,
  SELECTED_DISCOUNT,
  SELECTED_DISCOUNT_SUCCESS,
  SELECTED_DISCOUNT_ERROR,
} from "../../types/discount/selected-discount";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case SELECTED_DISCOUNT:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case SELECTED_DISCOUNT_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case SELECTED_DISCOUNT_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    default:
      return state;
  }
};

export default reducers;
